export const getSchemeExploreLink = ({ slug }: { slug: string }): string => {
  switch (slug) {
    case "art":
      return "/resources/champions-of-art";
    case "computing":
      return "/resources/digitalsparks";
    // French and Spanish currently share the same explore link
    case "french":
    case "spanish":
      return "/resources/lightning-languages";
    case "geography":
      return "/resources/geowonderers-resources";
    case "handwriting":
      return "/new-handwriting-scheme";
    case "history":
      return "/resources/history-seekers";
    case "music":
      return "/resources/masters-of-melody";
    case "physical-education":
      return "/pe-mastery";
    case "religion-worldviews":
      return "/resources/worldview-explorers";
    default:
      return "/resources/planit-primary-teaching-resources";
  }
};
